import {
  Button,
  Flex,
  Modal,
  ModalBody,
  ModalCloseButton,
  ModalContent, ModalFooter,
  ModalHeader,
  ModalOverlay
} from "@chakra-ui/react";
import { FormTextArea } from "../../../components/Forms";
import * as React from "react";
import { useTranslation } from "react-i18next";
import { useForm } from "react-hook-form";

function ViewSupplierNoteModal({ modalData, isOpen, onClose }) {
  const { t } = useTranslation("translation", {
    keyPrefix: "supplierNotes"
  });

  const {
    register
  } = useForm({
    defaultValues: modalData
  });

  return isOpen ?
    <Modal isOpen={isOpen} onClose={onClose} size="6xl">
      <ModalOverlay />
      <ModalContent>
        <ModalHeader>{t("modal.viewNoteHeader")}</ModalHeader>
        <ModalCloseButton />

        <ModalBody>
          <Flex direction="column" gap="2">
            <FormTextArea
              label={t("modal.labels.note")}
              {...register("supplierNote")}
              maxHeight="400"
              minHeight="400"
              readOnly={true}
            />
          </Flex>
        </ModalBody>

        <ModalFooter>
          <Button variant="ghost" mr={3} onClick={onClose}>
            {t("modal.buttons.close")}
          </Button>
        </ModalFooter>
      </ModalContent>
    </Modal> : null;
}

export default ViewSupplierNoteModal;